import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import {
    getPromocode,
    updateCart,
    emptyCart,
    getCartItems,
    getCartItemsLocal,
    toggleSignUp,
    placeNewOrder,
    successReport,
    calculateTotal,
    verifyDeliveryLocation,
    getUserDetails
} from '../../../store/actions/user/User';
import { upload } from "../../../store/actions/vendor/Vendor";
import { Input, Typography, withStyles } from '@material-ui/core';
import ProductCard from '../Cart/ProductCheckoutCart';
import PlacesWithStandaloneSearchBox from "../Home/map2";
import StripeCheckout from "../Cart/StripeCheckout";
import CheckoutForm from '../Checkout/CartCheckoutForm';
import Divider from '@material-ui/core/Divider';
import GridItem from "../../../components/Grid/GridItem.js";
import GridContainer from "../../../components/Grid/GridContainer.js";
import Footer from '../Footer/Footer';
import BackDrop from '../../../components/User/Preloader/BackDrop';
import CustomInput from "../../../components/CustomInput/CustomInput.js";
import { Label } from 'reactstrap';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const styles = (theme) => ({
    container: {
        minHeight: 'calc(120vh)',
        background: 'rgb(240, 245, 247)',
        paddingTop: '9%',
        [theme.breakpoints.down('sm')]: {
            paddingTop: '20%',
        }
    }
})

var promocode = ''
class PickAndDrop extends Component {

    constructor(props) {
        super(props)
        this.renderInvoice = this.renderInvoice.bind(this)
        this.handleAdressChange = this.handleAdressChange.bind(this)
        this.onUpload = this.onUpload.bind(this)
        this.textChange = this.textChange.bind(this)
        this.proceedToPayment = this.proceedToPayment.bind(this)
        this.renderPayementCondition = this.renderPayementCondition.bind(this)
        this.handlePaymentOptionChange = this.handlePaymentOptionChange.bind(this);
    }

    state = {
        promocode: 'Promo code not valid',
        color: 'red',
        flag: false,
        msg: '',
        disabled: false,
        show: false,
        paymentOption: null,
        showPaymentGateway: false,
        order: {
            pickUpAddress: {
                country_code: "+61",
                phone_number: localStorage.getItem("pickup_phone_number"),
                building_number: localStorage.getItem("pickup_building_number"),
                name: localStorage.getItem("pickup_name"),
            },
            dropAddress: {
                country_code: "",
                phone_number: ""
            },
            orderType: '2'
        }
    };

    componentDidMount() {
        const savedAddress = localStorage.getItem("pickup_address")
        const savedVal = localStorage.getItem("pickup_address_val")
        if (savedAddress && savedVal) {
            this.handleAdressChange('pick', JSON.parse(savedVal), 'pickUpAddress', JSON.parse(savedAddress))
        }
        if (this.props.auth) {
            this.props.getCartItems();
            this.props.getUserDetails();
        } else {
            this.props.getCartItemsLocal()
        }
    }

    onUpload(event) {
        this.setState({
            imageUploadMessage: "Uploading the file, please wait..."
        })
        const data = new FormData();
        data.append("files", event.target.files[0]);
        var self = this
        this.props
            .upload(data)
            .then((response) => {
                if (response.status === 201) {
                    var category = {}
                    this.setState({
                        imageUploadMessage: "File uploaded successfully."
                    })
                    var { order } = self.state
                    order.attachment = `${response.data.uploads[0].path}`;
                    self.setState({
                        order
                    })
                    // this.updateCategory(tempCategory);
                } else {
                    this.setState({
                        imageUploadMessage: "Please, try Again"
                    })
                }
            })
            .catch((error) => {
                this.setState({
                    imageUploadMessage: "An error occurred while executing the query. Please try Again"
                })
            });
    };

    componentDidUpdate(prevProps) {
        if (prevProps.auth !== this.props.auth) {
            if (this.props.auth) {
                this.props.getCartItems();
                this.props.getUserDetails();
            } else {
                this.props.getCartItemsLocal()
            }
        }
    }

    renderArrowDown() {
        return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="18px" width="16px" fill="white" class="sc-64ptou-0 bgXtBs"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path></svg>)
    }

    renderArrowUp() {
        return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="18px" width="16px" fill="white" class="sc-64ptou-0 bgXtBs"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path></svg>)
    }

    renderDot(fillDot, arrowDown) {
        return (<div style={{
            boxSizing: 'border-box',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            border: '3px solid rgba(183, 186, 195, 0.2)'
        }}>

            {fillDot ? <div style={{
                boxSizing: 'border-box',
                display: 'flex',
                '-webkit-box-align': 'center',
                alignItems: 'center',
                '-webkit-box-pack': 'center',
                justifyContent: 'center',
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: 'none',
                backgroundColor: 'rgb(1, 160, 90)'
            }}>{arrowDown ? this.renderArrowDown() : this.renderArrowUp()}</div>
                : <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    '-webkit-box-align': 'center',
                    alignItems: 'center',
                    '-webkit-box-pack': 'center',
                    justifyContent: 'center',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    border: '4px solid rgb(183, 186, 195)'
                }}>

                </div>}
        </div>)
    }

    clearTheCart() {
        this.props.emptyCart().then((data) => {
            this.props.getCartItems();
        });
    };

    handleSignIn() {
        this.props.toggleSignUp(true);
        this.setState({ signOpen: true });
    }

    handleAdressChange(key, value, stateKey, obj) {
        var { order } = this.state
        var address = obj
        order[stateKey].street = address.street
        order[stateKey].city = address.city
        order[stateKey].state = address.state
        order[stateKey].country = address.country
        order[stateKey].pincode = address.pincode
        order[stateKey].latitude = address.latitude
        order[stateKey].longitude = address.longitude
        var self = this
        var k = stateKey + '_error'
        this.setState({
            [k]: ''
        })
        if (this.props.auth) {
            this.props.verifyDeliveryLocation({ pincode: address.pincode }).then(resp => {
                if (resp?.status === 1) {
                    self.setState({
                        [key]: value,
                        order: order
                    })
                    self.calculatePrice()
                } else {
                    self.setState({
                        [k]: resp.message
                    })
                }
            }).catch((e) => {
            })
        }

    }

    calculatePrice() {
        const { pick, drop } = this.state;
        if (pick && drop) {
            this.props.calculateTotal({
                pickUpAddress: pick,
                dropAddress: drop
            })
        }
    }

    textChange(key1, key2, val) {
        var { order } = this.state
        order[key1][key2] = val
        this.setState({
            order
        })
    }

    textSingleChange(key1, val) {
        var { order } = this.state
        order[key1] = val
        this.setState({
            order
        })
    }

    renderPickupLocation() {
        const locationRef = React.createRef();
        return (<div>
            <b>Pickup Location*</b>
            <PlacesWithStandaloneSearchBox
                location={locationRef}
                value={localStorage.getItem("pickup_address")}
                handleChange={(val, place) => {
                    localStorage.setItem("pickup_address", JSON.stringify(place))
                    localStorage.setItem("pickup_address_val", JSON.stringify(val))
                    this.handleAdressChange('pick', val, 'pickUpAddress', place)
                }}
            ></PlacesWithStandaloneSearchBox>
            <p style={{ color: 'red' }}>{this.state.pickUpAddress_error}</p>
            <br></br>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <b></b>
                    <div>
                        <CustomInput labelText="FLAT, FLOOR, BUILDING NAME*"
                            id="pickFlat"
                            value={localStorage.getItem("pickup_building_number")}
                            name="pickFlat"
                            onChange={(event) => {
                                localStorage.setItem("pickup_building_number", event.target.value)
                                this.textChange('pickUpAddress', 'building_number', event.target.value)
                            }}
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <div>
                        <CustomInput labelText="Phone Number*"
                            id="pickPhone"
                            value={localStorage.getItem("pickup_phone_number")}
                            name="pickPhone"
                            onChange={(event) => {
                                localStorage.setItem("pickup_phone_number", event.target.value)
                                this.textChange('pickUpAddress', 'phone_number', event.target.value)
                            }}
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <div>
                        <CustomInput labelText="Name"
                            id="pickName"
                            value={localStorage.getItem("pickup_name")}
                            name="pickName"
                            onChange={(event) => {
                                localStorage.setItem("pickup_name", event.target.value)
                                this.textChange('pickUpAddress', 'name', event.target.value)
                            }}
                            formControlProps={{
                                fullWidth: true,
                            }}
                        /></div>
                </GridItem>
            </GridContainer>
        </div>)
    }

    renderDropLocation() {
        const locationRef = React.createRef();
        const { pick, drop, imageUploadMessage, order } = this.state
        var valid = false
        if (pick && drop && order.pickUpAddress.building_number && order.dropAddress.building_number) {
            valid = true
        }
        return (<div>
            <b>Drop Location*</b>
            <PlacesWithStandaloneSearchBox
                location={locationRef}
                handleChange={(val, place) => {
                    this.handleAdressChange('drop', val, 'dropAddress', place)
                }}
            ></PlacesWithStandaloneSearchBox>
            <p style={{ color: 'red' }}>{this.state.dropAddress_error}</p>
            <br></br>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <b></b>
                    <div>
                        <CustomInput labelText="FLAT, FLOOR, BUILDING NAME*"
                            id="dropFlat"
                            name="dropFlat"
                            onChange={(event) => {
                                this.textChange('dropAddress', 'building_number', event.target.value)
                            }}
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <div>
                        <CustomInput labelText="Phone Number"
                            id="dropPhone"
                            name="dropPhone"
                            onChange={(event) => {
                                this.textChange('dropAddress', 'phone_number', event.target.value)
                            }}
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <div>
                        <CustomInput labelText="Name"
                            id="dropName"
                            name="dropName"
                            onChange={(event) => {
                                this.textChange('dropAddress', 'name', event.target.value)
                            }}
                            formControlProps={{
                                fullWidth: true,
                            }}
                        /></div>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <b></b>
                    <div>
                        <CustomInput labelText="Number of Packages"
                            id="noOfPackages"
                            name="noOfPackages"
                            type="number"
                            onChange={(event) => {
                                this.textSingleChange('noOfPackages', event.target.value)
                            }}
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <b></b>
                    <div>
                        <CustomInput labelText="Note"
                            id="note"
                            name="note"
                            type="text"
                            onChange={(event) => {
                                this.textSingleChange('note', event.target.value)
                            }}
                            formControlProps={{
                                fullWidth: true,
                            }}
                        />
                    </div>
                </GridItem>
            </GridContainer>
            <div style={{ marginBottom: '5%' }}>
                <CustomInput
                    labelText="Package Image"
                    id="icon"
                    type="file"
                    name="icon"
                    accept="image/*"
                    onChange={this.onUpload}
                    formControlProps={{
                        fullWidth: true,
                    }}
                />
                <p style={{ color: "#000" }}>{imageUploadMessage}</p>
                <b>Package Image</b>
            </div>
            <p style={{
                width: '80%',
                fontSize: '10px',
            }}>By continuing I accept this order doesn’t contain illegal/resticted items, if illegal/restricted items are found by Grospick Partner, they may report it to the law enforcement authorities.Terms and Conditions</p>
            {!this.props.auth &&
                <div onClick={this.handleSignIn.bind(this)} style={{
                    width: '222px',
                    height: '54px',
                    background: 'rgb(1, 160, 90)',
                    border: '1px solid rgb(1, 160, 90)',
                    color: '#fff',
                    borderRadius: '30px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    padding: '0 5px',
                    marginLeft: '10%',
                    userSelect: 'none',
                    '&:hover': {
                        boxShadow: '1px 1px 2px #000000'
                    }
                }}>
                    <div >Sign In to Confirm Order</div>
                </div>
            }
        </div>)
    }

    handleAddressSave(checkoutAddress) {
        this.setState({
            addressSaved: true,
            checkoutAddress
        })
    }

    renderAddress(auth) {
        return (<div>
            <div style={{ display: 'flex' }}>
                <h4 style={{ color: auth ? 'black' : '#A09E9E', flexGrow: '1' }}>Add delivery address</h4>
                {this.state.addressSaved &&
                    <div onClick={() => {
                        this.setState({
                            addressSaved: false
                        })
                    }} style={{
                        width: '53px',
                        height: '22px',
                        background: 'rgb(1, 160, 90)',
                        border: '1px solid rgb(1, 160, 90)',
                        color: '#fff',
                        borderRadius: '30px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        padding: '0 5px',
                        userSelect: 'none',
                        '&:hover': {
                            boxShadow: '1px 1px 2px #000000'
                        },
                        fontSize: '10px'
                    }}>
                        <div>Change</div>
                    </div>
                }
            </div>
            {auth ?
                <CheckoutForm handleAddressSave={this.handleAddressSave.bind(this)} addressSaved={this.state.addressSaved} />
                :
                <p style={{ color: '#A09E9E' }}>Choose your delivery address from address book or add new</p>
            }
        </div>)
    }

    proceedToPayment = (token) => {
        var tempPayload = { ...this.state.order, payment_token: token?.id };
        tempPayload.totalPrice = this.props.price.price + ''
        tempPayload.distance = this.props.price.distanceKm + " Km"
        this.props.placeNewOrder(tempPayload).then(async (data) => {
            this.props.successReport('Order Places Successfully')
            this.props.history.push('/')
        }).catch(err => {

        })
    };

    handlePaymentOptionChange = (event) => {
        if (event.target.value === 'wallet' || 'rechargeWallet') {
            var tempPayload = { ...this.state.order, useWallet: true };
            this.setState({
                order: tempPayload
            })
        }
        this.setState({
            paymentOption: event.target.value,
        })
    };

    handleProceedToPay = () => {
        const { paymentOption } = this.state
        if (paymentOption === 'wallet') {
            this.proceedToPayment({ id: 'NOT_REQUIRED' })
        } else {
            this.setState({
                showPaymentGateway: true,
            })
        }
    }

    renderPayementCondition() {
        const { userDetails } = this.props
        const gt = !this.props.price || !this.props.price.price ? 0 : this.props.price.price
        const { paymentOption, showPaymentGateway } = this.state;
        if (!showPaymentGateway && userDetails.walletAmount && userDetails.walletAmount >= gt) {
            return <FormControl component="fieldset">
                <FormLabel component="legend">Choose Payment Option</FormLabel>
                <RadioGroup aria-label="paymentOption" name="paymentOption" value={paymentOption} onChange={this.handlePaymentOptionChange.bind(this)}>
                    <FormControlLabel value="wallet" control={<Radio />} label={`Use Wallet Balance (Wallet Balance ${userDetails.walletAmount})`} />
                    <FormControlLabel value="card" control={<Radio />} label="Pay By Card" />
                </RadioGroup>
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                    <button
                        className="site-btn btnAdd submit-order-btn"
                        style={{ color: !paymentOption ? "black" : "white", background: !paymentOption ? "#ffffff" : "rgb(1, 160, 90)" }}
                        disabled={!paymentOption}
                        onClick={this.handleProceedToPay.bind(this)}
                    >
                        Proceed To Pay
              </button>
                </div>
            </FormControl>
        }
        else if (!showPaymentGateway && userDetails.walletAmount && userDetails.walletAmount < gt) {
            return <FormControl component="fieldset">
                <FormLabel component="legend">Choose Payment Option</FormLabel>
                <RadioGroup aria-label="paymentOption" name="paymentOption" value={paymentOption} onChange={this.handlePaymentOptionChange.bind(this)}>
                    <FormControlLabel value="rechargeWallet" control={<Radio />} label={`Racharge Wallet and Pay (Wallet Balance ${userDetails.walletAmount})`} />
                    <FormControlLabel value="card" control={<Radio />} label="Pay By Card" />
                </RadioGroup>
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                    <button
                        className="site-btn btnAdd submit-order-btn"
                        style={{ color: !paymentOption ? "black" : "white", background: !paymentOption ? "#ffffff" : "rgb(1, 160, 90)" }}
                        disabled={!paymentOption}
                        onClick={this.handleProceedToPay.bind(this)}
                    >
                        Proceed To Pay
              </button>
                </div>
            </FormControl>
        } else {
            return <StripeCheckout handlePayment={this.proceedToPayment.bind(this)} />
        }
    }

    renderPayement(addressSaved) {
        return (<div>
            { addressSaved ?
                this.renderPayementCondition()
                : <>
                    <h4 style={{ color: '#A09E9E' }}>Select payment method</h4>
                    <p style={{ color: '#A09E9E' }}>Select your payment method from the existing one or add new one <b>(Fill all the required fields before payment)</b></p>
                </>
            }
        </div>)
    }


    renderInvoice() {
        const { t, gt, p } = this.state;
        return (
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '4%' }}>
                <div style={{
                    background: 'white', width: '100%', borderRadius: '5px', marginBottom: '4%',
                    padding: '8%',
                    textAlign: 'left',
                    paddingBottom: '12%'
                }}>
                    <h5>Invoice</h5>
                    {!this.props.auth && <div style={{ color: '#A09E9E', fontSize: '12px' }}>Delivery charges may change after signing in</div>}
                    <div style={{ display: 'flex', paddingTop: '30px', paddingBottom: '10px' }}>
                        <div style={{ flex: '1 1 0%' }}>
                            <span style={{ fontSize: '12px' }}>Partner Delivery Fee</span>
                        </div>
                        <div>
                            <span style={{ fontSize: '12px' }}>AUD {!this.props.price || !this.props.price.price ? 0 : this.props.price.price}</span>
                        </div>
                    </div>
                    <Divider></Divider>
                    <div style={{ display: 'flex', paddingTop: '10px' }}>
                        <div style={{ flex: '1 1 0%' }}>
                            <span style={{ fontSize: '13px' }}><b>To Pay</b></span>
                        </div>
                        <div>
                            <span style={{ fontSize: '13px' }}><b>AUD {!this.props.price || !this.props.price.price ? 0 : this.props.price.price}</b></span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderBox(showTop, showBottom, fillDot, arrowDown, comp) {
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    position: 'relative',
                    left: '0px',
                    top: '10%',
                    bottom: '0px',
                    width: '30px',
                    marginRight: '10px',
                    flexDirection: 'column',
                    '-webkit-box-align': 'center',
                    'align-items': 'center',
                }}>
                    <div style={{
                        'box-sizing': 'border-box',
                        width: '2px',
                        borderRight: '2px dashed rgb(231, 232, 235)',
                        opacity: showTop ? '1' : '0',
                        marginTop: '4px',
                        height: '36px'
                    }}>

                    </div>
                    {this.renderDot(fillDot, arrowDown)}
                    <div style={{
                        boxSizing: 'border-box',
                        width: '2px',
                        borderRight: '2px dashed rgb(231, 232, 235)',
                        opacity: showBottom ? '1' : '0',
                        flex: '1 1 0%'
                    }}>

                    </div>

                </div>
                <div style={{
                    background: 'white', width: '100%', borderRadius: '5px', marginBottom: '4%',
                    padding: '4%',
                    textAlign: 'left'
                }}>
                    {comp}
                </div>
            </div>
        )
    }

    renderSignIn() {
        return (<div>
            <h4>{'Sign in to place your order'}</h4>
            <p>New to Grospick? Sign up now to get started! Or log in to your existing account.</p>
            <div onClick={this.handleSignIn.bind(this)} style={{
                width: '222px',
                height: '54px',
                background: 'rgb(1, 160, 90)',
                border: '1px solid rgb(1, 160, 90)',
                color: '#fff',
                borderRadius: '30px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                padding: '0 5px',
                userSelect: 'none',
                '&:hover': {
                    boxShadow: '1px 1px 2px #000000'
                }
            }}>
                <div >Sign In</div>
            </div>
        </div>)
    }


    render() {
        const { classes, user, api_progress } = this.props;
        const { pick, drop, imageUploadMessage, order } = this.state
        var valid = false
        if (pick && drop && order.pickUpAddress.building_number && order.dropAddress.building_number) {
            valid = true
        }
        return (
            <div>
                <BackDrop open={api_progress}></BackDrop>
                <div className={classes.container}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={1}>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={7}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div style={{
                                    padding: '5%',
                                    background: 'white',
                                    textAlign: 'left',
                                    height: '100%'
                                }}>
                                    <h4>Send Packages</h4>
                                    <p>Your on demand local courier</p>
                                    {!this.props.auth &&
                                        (this.renderBox(false, true, false, false, this.renderSignIn()))
                                    }
                                    {this.props.auth &&
                                        (this.renderBox(false, true, this.state.pick && order.pickUpAddress.building_number && order.pickUpAddress.phone_number ? true : false, false, this.renderPickupLocation()))
                                    }
                                    {this.props.auth &&
                                        (this.renderBox(true, true, this.state.drop && order.dropAddress.building_number, true, this.renderDropLocation()))
                                    }
                                    {this.renderBox(true, false, false, false, this.renderPayement(valid))}
                                </div>
                            </GridItem>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={3}>
                            <div style={{
                                paddingLeft: '1%',
                                paddingTop: '4%',
                                background: 'white',
                                marginLeft: '2%',
                                height: '100%'
                            }}>
                                {this.renderInvoice()}
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
                <Footer />
            </div>)
    }
}


const mapStateWithProps = (state) => ({
    cart: state.user.cart,
    promocode: state.user.promocode,
    auth: state.user.auth,
    api_progress: state.user.api_progress,
    price: state.price,
    userDetails: state.user.userDetails
});

const mapDispatchToProps = (dispatch) => ({
    getPromocode: () => dispatch(getPromocode()),
    emptyCart: () => dispatch(emptyCart()),
    updateCart: (product) => dispatch(updateCart(product)),
    getCartItems: () => dispatch(getCartItems()),
    toggleSignUp: (isOpen) => dispatch(toggleSignUp(isOpen)),
    getCartItemsLocal: () => dispatch(getCartItemsLocal()),
    placeNewOrder: (checkout) => dispatch(placeNewOrder(checkout)),
    successReport: (message) => dispatch(successReport(message)),
    calculateTotal: (address) => dispatch(calculateTotal(address)),
    upload: (data) => dispatch(upload(data)),
    getUserDetails: () => dispatch(getUserDetails()),
    verifyDeliveryLocation: (data) => dispatch(verifyDeliveryLocation(data)),
});

export default withStyles(styles)(connect(mapStateWithProps, mapDispatchToProps)(PickAndDrop));